export const PracticeLabelContainer = {
  margin: '0 60px 0 60px',
  '@media screen and (max-width: 1300px)': {
    margin: '0 20px 0 20px'
  },
  '@media screen and (max-width: 420px)': {
    margin: '0 10px 0 10px'
  }
};
